<div class="header">
    <div class="label">{{ getDate() }}</div>
    <div class="title-element">Formateurs</div>
    <div class="title-element">Durée estimée</div>
    <div class="title-element">Etat</div>
    <div class="icon-close" (click)="closeDialog()"></div>
</div>
<mat-dialog-content>
    <div class="container" *ngIf="eventsToDo.length">
        <div class="title">A faire</div>

        <div class="event-container">
            <div class="event" *ngFor="let event of eventsToDo">
                <div *ngIf="event.type === 'call'">
                    <div class="sub-title">Vous êtes inscrits à un easi call</div>
                    <div class="entry">
                        <div class="title-content">
                            <div class="icon icon-easi-call-plein"></div>
                            <div>{{ event.name }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>
                        <div class="duration">{{ event.duration }}</div>
                        <div class="blank"></div>
                    </div>
                </div>
                <div *ngIf="event.type === 'training' && !event.level">
                    <div class="sub-title">Vous devez terminer l'activité</div>
                    <div class="entry" (click)="launchContent($event, event)">
                        <div class="title-content">
                            <div class="icon" [ngClass]="getIcon(event)"></div>
                            <div>{{ event.title }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>
                        <div class="duration">{{ event.content_duration }}:00</div>
                        <div class="tracking">
                            <div class="score" *ngIf="canViewScore(event)">
                                {{ event.tracking.score }}/100
                            </div>
                            <div
                                class="icon"
                                [ngClass]="[
                                    getTrackingStatusIconStyle(event),
                                    isForcedStatus(event)
                                ]"
                                [tooltip]="getTrackingStatusText(event)"
                            ></div>
                        </div>
                    </div>
                </div>
                <div *ngIf="event.type === 'training' && event.level">
                    <div class="sub-title">Vous devez terminer {{ getContentLevel(event) }}</div>
                    <div class="entry">
                        <div class="title-content">
                            <div class="icon" [ngClass]="getIcon(event)"></div>
                            <div>{{ event.title }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>
                        <div class="duration">{{ event.content_duration }}:00</div>
                        <div class="progress-bar">
                            <div
                                class="progression"
                                [ngStyle]="{ width: event.completion + '%' }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="separator"></div>
    <div class="container" *ngIf="eventsDone.length">
        <div class="title">Terminé</div>
        <div class="event-container">
            <div class="event" *ngFor="let event of eventsDone">
                <div *ngIf="event.type === 'call'">
                    <div class="sub-title">Vous avez participé à un easi call</div>
                    <div class="entry">
                        <div class="title-content">
                            <div class="icon icon-easi-call-plein"></div>
                            <div>{{ event.name }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>

                        <div class="duration">{{ event.duration }}</div>
                        <div class="blank"></div>
                    </div>
                </div>
                <div *ngIf="event.type === 'training' && !event.level">
                    <div class="sub-title">Vous avez terminé l'activité</div>
                    <div class="entry activity" (click)="launchContent($event, event)">
                        <div class="title-content">
                            <div class="icon" [ngClass]="getIcon(event)"></div>
                            <div>{{ event.title }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>

                        <div class="duration">{{ event.content_duration }}:00</div>
                        <div class="tracking">
                            <div class="score" *ngIf="canViewScore(event)">
                                {{ event.tracking.score }}/100
                            </div>
                            <div
                                class="icon"
                                [ngClass]="[
                                    getTrackingStatusIconStyle(event),
                                    isForcedStatus(event)
                                ]"
                                [tooltip]="getTrackingStatusText(event)"
                            ></div>
                        </div>
                        <div class="tracking-hover">
                            <div
                                class="launch-button"
                                *ngIf="canLaunchContent(event)"
                                (click)="launchContent($event, event)"
                            >
                                <span>Lancer</span>
                                <span class="icon-Lancer"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="event.type === 'training' && event.level">
                    <div class="sub-title">Vous avez terminé {{ getContentLevel(event) }}</div>
                    <div class="entry">
                        <div class="title-content">
                            <div class="icon" [ngClass]="getIcon(event)"></div>
                            <div>{{ event.title }}</div>
                        </div>
                        <div class="referent">
                            <ng-container *ngIf="getReferent(event)?.avatar">
                                <div
                                    class="avatar"
                                    [ngClass]="getConnectionStatus(event)"
                                    (click)="chatUser(event)"
                                >
                                    <img class="" [src]="getReferent(event)?.avatar" />
                                </div>
                            </ng-container>

                            <div *ngIf="!getReferent(event)?.avatar">
                                <div class="empty avatar">
                                    {{ getUserInitial(event) }}
                                </div>
                            </div>
                            <div class="referent-hover">
                                {{
                                    getReferent(event).lastname.toUpperCase() +
                                        ' ' +
                                        getReferent(event).firstname
                                }}
                            </div>
                        </div>

                        <div class="duration">{{ event.content_duration }}:00</div>
                        <div class="progress-bar">
                            <div
                                class="progression"
                                [ngStyle]="{ width: event.completion + '%' }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
